import React, { useState } from "react";
import NewUiHeader from "../../CustomComponents/NewComponents/NewUIHeader/NewUIHeader";
import NewFooterUI from "../../CustomComponents/NewComponents/NewFooterUI/NewFooterUI";
import cubes from "../../assets/new-images/wooden-cubes.png";
import { Link as ScrollLink, animateScroll as scroll } from "react-scroll";
import style from "./IntegrationPage.module.scss";
import { Link } from "react-router-dom";
import revImg from "../../assets/new-images/revcatalyst-logo.png";
import ntt from "../../assets/new-images/ntt.png";
import razorpay from "../../assets/new-images/razorpay.png";
import travel from "../../assets/new-images/travel.png";
import banner from "../../assets/new-images/integration-banner.jpg";

const IntegrationPage = () => {
  const accordionItems = [
    {
      id: 1,
      header: "How do I book a tour with your agency?",
      content:
        "You can book a tour with us by visiting our website and filling out the booking form, or by contacting our customer service team directly via phone or email.",
    },
    {
      id: 2,
      header: "What destinations do you offer tours to?",
      content:
        "We offer tours to a wide range of destinations, including popular tourist spots as well as off-the-beaten-path locations. Our destinations include Shimla, Manali, Dharamshala, Dalhousie, Khajjiar, Kasol, Palampur, Bir-Billing, Spiti, Tabo, Chitkul, Chamba, Keylong, Losar, Chail, Kalpa, Theog, Barot Valley, Bhuntar, Sangla and many more.",
    },
    {
      id: 3,
      header: "Can you customize a tour itinerary to suit my preferences?",
      content:
        "Yes, we specialize in creating customized tour itineraries tailored to your preferences. Whether you're interested in cultural experiences, adventure activities, or relaxation, we can design a tour that meets your needs.",
    },
    {
      id: 4,
      header: "What types of accommodation do you provide during the tours?",
      content:
        "We offer a variety of accommodation options ranging from budget-friendly hotels to luxury resorts, ensuring your comfort and satisfaction throughout the tour.",
    },
    {
      id: 3,
      header: "Do your tour packages include meals and activities?",
      content:
        "Yes, our tour packages typically include meals as specified in the itinerary and a range of activities and excursions designed to enhance your travel experience.",
    },
    {
      id: 4,
      header: "How do I make payments for the tour packages?",
      content:
        "Payments can be made securely through our online payment gateway on our website. We accept major credit cards and other forms of electronic payment.",
    },
    {
      id: 4,
      header: "What is included in the tour package price?",
      content:
        "The tour package price includes accommodation, meals as specified, transportation during the tour, guided tours and activities as outlined in the itinerary, and applicable taxes and fees.",
    },
    {
      id: 4,
      header: "What are your cancellation and refund policies?",
      content:
        "Our cancellation and refund policies vary depending on the tour package and timing of cancellation. Please refer to our terms and conditions or contact our customer service team for detailed information.",
    },
    {
      id: 4,
      header:
        "Are there any additional fees or charges not included in the tour package price?",
      content:
        "Additional fees such as optional activities, personal expenses, travel insurance, and gratuities may not be included in the tour package price. Please check the specific inclusions and exclusions for each tour package.",
    },
    {
      id: 4,
      header: "How far in advance should I book a tour?",
      content:
        "We recommend booking your tour as early as possible to ensure availability, especially during peak travel seasons. Some tours may require booking several months in advance to secure preferred accommodations and activities.",
    },
  ];
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    if (activeIndex === index) {
      setActiveIndex(null);
    } else {
      setActiveIndex(index);
    }
  };

  const channnelPatnersData = [
    {
      title: "RevCatalyst",
      img: revImg,
      description:
        "    Lorem ipsum dolor sit amet consectetur.Lorem ipsum dolor sit amet consectetur.Lorem ipsum dolor sit amet consectetur",
    },
    {
      title: "RevCatalyst",
      img: revImg,
      description:
        "    Lorem ipsum dolor sit amet consectetur.Lorem ipsum dolor sit amet consectetur.Lorem ipsum dolor sit amet consectetur",
    },
    {
      title: "RevCatalyst",
      img: revImg,
      description:
        "    Lorem ipsum dolor sit amet consectetur.Lorem ipsum dolor sit amet consectetur.Lorem ipsum dolor sit amet consectetur",
    },
    {
      title: "RevCatalyst",
      img: revImg,
      description:
        "    Lorem ipsum dolor sit amet consectetur.Lorem ipsum dolor sit amet consectetur.Lorem ipsum dolor sit amet consectetur",
    },
    {
      title: "RevCatalyst",
      img: revImg,
      description:
        "    Lorem ipsum dolor sit amet consectetur.Lorem ipsum dolor sit amet consectetur.Lorem ipsum dolor sit amet consectetur",
    },
    {
      title: "RevCatalyst",
      img: revImg,
      description:
        "    Lorem ipsum dolor sit amet consectetur.Lorem ipsum dolor sit amet consectetur.Lorem ipsum dolor sit amet consectetur",
    },
    {
      title: "RevCatalyst",
      img: revImg,
      description:
        "    Lorem ipsum dolor sit amet consectetur.Lorem ipsum dolor sit amet consectetur.Lorem ipsum dolor sit amet consectetur",
    },
    {
      title: "RevCatalyst",
      img: revImg,
      description:
        "    Lorem ipsum dolor sit amet consectetur.Lorem ipsum dolor sit amet consectetur.Lorem ipsum dolor sit amet consectetur",
    },
    {
      title: "RevCatalyst",
      img: revImg,
      description:
        "    Lorem ipsum dolor sit amet consectetur.Lorem ipsum dolor sit amet consectetur.Lorem ipsum dolor sit amet consectetur",
    },
  ];

  return (
    <div className={style.integration}>
      <NewUiHeader />
      <section>
        <div
          className={style.top_banner}
          style={{ justifyContent: "start" }}
        >
          {" "}
          {/* <img src={banner} alt="banner image" /> */}
          <div className={style.banner_content}>
           <div className="container"> <h2>Meet Our Connectivity Partners</h2>
            <p className="mt-20 ">We integrated Successfully with 8 partners</p>
            <div className="mt-20 ">
              {" "}
              <ScrollLink
                to="agentRegister"
                smooth="easeInOutQuad"
                duration={500}
                className="LoginVendor_banner_getStarted red_new_btn hoverCursor"
              >
                View all Partners
              </ScrollLink>
            </div></div>
          </div>
        </div>
      </section>
      <section
        className="LoginVendor_padding_feature"
        style={{ background: "#FFFCF3" }}
      >
        <div className="container">
          <div className="main_div_flex">
            <div className="img_div">
              <img src={cubes} alt="agent-image" />
            </div>
            <div className="description-content">
              <p className={style.desc}>
                We continuously integrate various travel technologies to help
                our customers choose from the best products available
              </p>{" "}
              <div className="">
                {" "}
                <ScrollLink
                  to="agentRegister"
                  smooth="easeInOutQuad"
                  duration={500}
                  className="LoginVendor_banner_getStarted red_new_btn hoverCursor"
                >
                  View all Partners
                </ScrollLink>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        className="LoginVendor_padding_feature"
        style={{ background: "#F3F3F3" }}
      >
        <div className="container">
          <h3>Our Channel Partners</h3>
          <p className="text-center">
            Lorem ipsum dolor sit amet consectetur. Ultricies fermentum nunc
            tellus felis. Enim ut ac adipiscing tincidunt.
          </p>
          <div className={style.flex_data}>
            {channnelPatnersData?.map((item, i) => (
              <div className={style.card} key={i}>
                <div className={style.img_div}>
                  <img src={item?.img} alt="agent-image" />
                </div>
                <div className={style.content}>
                  <h4>{item?.title}</h4>
                  <p>{item?.description}</p>
                  <Link to="">
                    Visit website{" "}
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <mask
                        id="mask0_7573_4470"
                        style={{ maskType: "alpha" }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="16"
                        height="16"
                      >
                        <rect
                          width="16"
                          height="16"
                          transform="matrix(-1 0 0 1 16 0)"
                          fill="#D9D9D9"
                        />
                      </mask>
                      <g mask="url(#mask0_7573_4470)">
                        <path
                          d="M11.0847 8.5L7.28717 12.2975L8 13L13 8L8 3L7.28717 3.7025L11.0847 7.5H3V8.5H11.0847Z"
                          fill="#EB442D"
                        />
                      </g>
                    </svg>
                  </Link>
                </div>
              </div>
            ))}
          </div>{" "}
          <div className="mt-40 flex justify_content_center">
            {" "}
            <ScrollLink
              to="agentRegister"
              smooth="easeInOutQuad"
              duration={500}
              className="LoginVendor_banner_getStarted red_new_btn hoverCursor"
            >
              Request channel intigration
            </ScrollLink>
          </div>
        </div>
      </section>
      <section className="common_padding">
        <div className="container">
          <h3>Our Payment Partners</h3>
          <p className="text-center">
            Lorem ipsum dolor sit amet consectetur. Ultricies fermentum nunc
            tellus felis. Enim ut ac adipiscing tincidunt.
          </p>
          <div className={style.flex_data} id={style.center_align}>
            <div className={style.card}>
              <div className={style.img_div}>
                <img src={ntt} alt="ntt logo" />
              </div>
              <div className={style.content}>
                <h4>NTT Data</h4>
                <p>
                  Lorem ipsum dolor sit amet consectetur. Posuere diam quam nam
                  fames commodo. Urna commodo platea elit tincidunt mus laoreet.
                  Tellus eget sit eu consequat.
                </p>
                <Link to="">
                  Visit website{" "}
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_7573_4470"
                      style={{ maskType: "alpha" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="16"
                      height="16"
                    >
                      <rect
                        width="16"
                        height="16"
                        transform="matrix(-1 0 0 1 16 0)"
                        fill="#D9D9D9"
                      />
                    </mask>
                    <g mask="url(#mask0_7573_4470)">
                      <path
                        d="M11.0847 8.5L7.28717 12.2975L8 13L13 8L8 3L7.28717 3.7025L11.0847 7.5H3V8.5H11.0847Z"
                        fill="#EB442D"
                      />
                    </g>
                  </svg>
                </Link>
              </div>
            </div>
            <div className={style.card}>
              <div className={style.img_div}>
                <img src={razorpay} alt="ntt logo" />
              </div>
              <div className={style.content}>
                <h4>Razorpay</h4>
                <p>
                  Lorem ipsum dolor sit amet consectetur. Posuere diam quam nam
                  fames commodo. Urna commodo platea elit tincidunt mus laoreet.
                  Tellus eget sit eu consequat.
                </p>
                <Link to="">
                  Visit website{" "}
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_7573_4470"
                      style={{ maskType: "alpha" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="16"
                      height="16"
                    >
                      <rect
                        width="16"
                        height="16"
                        transform="matrix(-1 0 0 1 16 0)"
                        fill="#D9D9D9"
                      />
                    </mask>
                    <g mask="url(#mask0_7573_4470)">
                      <path
                        d="M11.0847 8.5L7.28717 12.2975L8 13L13 8L8 3L7.28717 3.7025L11.0847 7.5H3V8.5H11.0847Z"
                        fill="#EB442D"
                      />
                    </g>
                  </svg>
                </Link>
              </div>
            </div>
          </div>{" "}
        </div>
      </section>
      <section className="common_padding">
        <div className={style.travel_banner}>
          {" "}
          <img src={travel} alt="travel image" />
          <div className={style.banner_content}>
            <h2>Grow your business with Mountain Mysteries</h2>
            <div className="mt-20 flex justify_content_center">
              {" "}
              <ScrollLink
                to="agentRegister"
                smooth="easeInOutQuad"
                duration={500}
                className="LoginVendor_banner_getStarted red_new_btn hoverCursor"
              >
                Request channel intigration
              </ScrollLink>
            </div>
          </div>
        </div>
      </section>
      {/* FAQ */}
      <section className="LoginVendor_padding LoginVendor_shade">
        <div className="container">
          <h3 className="text-left">FAQs</h3>
          {accordionItems.map((item, index) => (
            <div className="accordion mb-20 mt-10" key={index}>
              <div
                className="accordion-item"
                style={{ border: "0" }}
                key={index}
              >
                <div
                  className="flex justify_content_between p_10 cursor_pointer accordion_icon align_items_center"
                  onClick={() => toggleAccordion(index)}
                >
                  <div
                    className="accordion-item-header"
                    style={{ fontWeight: "500" }}
                  >
                    {item.header}
                  </div>
                  <svg
                    className={`accordion-icon ${
                      activeIndex === index ? "rotated" : ""
                    }`}
                    width="10"
                    height="10"
                    viewBox="0 0 9 5"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M8.25 0.75L4.75 4.25L1.25 0.75" stroke="#000" />
                  </svg>
                </div>
                <div
                  className={`accordion-item-body ${
                    activeIndex === index ? "active" : ""
                  }`}
                >
                  <div className="accordion-item-body-content">
                    {item.content}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>{" "}
      <NewFooterUI />
    </div>
  );
};

export default IntegrationPage;
